import ZtServiceFactory from '@src/services/zt';
const $ztService = ZtServiceFactory.getDefaultInstance();
// //console.log('service:', $ztService);
const Service = {
  /**
   * 获取
   * @returns {*}
   //  */
  // getConfig: () => $ztService.getGiftPackConfig(),
  /**
   * 公测礼包
   */
  gwConfig: () => $ztService.gwConfig(),
  /**
   *  退出登录态
   */
  logout: () => $ztService.logout(),
  /**
   *  公测下载福利码
   */
  getDownLoadCode: () => $ztService.getCodeInDownLoad()
};

export default Service;
